import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";
import {
    columnsTable,
    genaratePaginateFilterSort,
    getDataSource,
    getTitleTable,
    removeObjectNull, removeObjectNullFull
} from "../../../../utils/functions";
import {omit} from "lodash";
import TAG_DEFINE from "../../../../constants/common";
import {PATHS} from "../../../../constants/define";
import PERMISSION from "../../../../constants/permission";

// ============== LAYOUT ==============
import HeaderAction from "../../../common/layout/HeaderAction";
import {Icon} from "../../../common";
import {ListComponent} from "../../../common/ListComponent";
import {ListSearchFreeTextComponent} from "../../../../utils/commonUtils";

// ============== ACTION ==============
// import {ActionGetListUser, ActionInit, ActionMasterData} from '../../../../data/hooks/user';
import {ActionGetListCustomer} from '../../../../data/hooks/customer';
import {ActionGetListSubscriptionCustomer} from '../../../../data/hooks/subscriptionCustomer';
import {ActionGetListSubscriptionPackage, ActionMasterData} from '../../../../data/hooks/subscriptionPackage';
import {Tooltip, Button, Tag, Form, Input, Select, DatePicker} from 'antd'

// ============== SELECT DATA ==============
// import {selectListUser, selectMasterData} from '../../../../data/reselects/userSelector';
import {selectListCustomer} from '../../../../data/reselects/customerSelector';
import {
    selectFetching,
    selectErrors,
    selectListSubscriptionPackage,
    selectMasterData
} from '../../../../data/reselects/subscriptionPackageSelector';
import SubscriptionPackageResponse, {listCols} from "../../../../data/mapping/Response/SubscriptionPackageResponse";
import {common} from "../../../../data/mapping/Request/UserRequest";
import {constants} from "../../../../data/mapping/Response/SubscriptionCustomerResponse";


const ModelFields = Object.getOwnPropertyNames(new SubscriptionPackageResponse());
const Index = props => {
    const namePage = "subscription_packages",
        [initData, setInitData] = useState({
            titleItemTable: getTitleTable(listCols, ['action'], []),
            modelItem: ModelFields,
        }),
        [paramsFilters, setPramsFilters] = useState({}),
        [form] = Form.useForm(),
        componentTable = {
            status: {
                width: 150,
                render: (val, record) => constants.status[val],
            },
            action: {
                width: 100,
                align: 'center',
                key: 'action',
                fixed: 'right',
                render: (text, record) => <Icon type="edit-outlined" className="cursorPointer"
                                                onClick={() => props.history.push((PERMISSION.SUBSCRIPTION.PACKAGE_UPDATE.route).replace(":id", record.id), {
                                                    group: PERMISSION.SUBSCRIPTION.PACKAGE_UPDATE.group,
                                                    withParams: true
                                                })}/>,
            }
        };
    const [isFetching, setIsFetching] = useState(false),
        [resultList, setResultList] = useState([]),
        [pagination, setPagination] = useState({}),
        // ============== ACTION ==============
        getListSubscriptionPackages = ActionGetListSubscriptionPackage(),
        getMasterData = ActionMasterData(),
        // ============== SELECT DATA ==============
        itemListSubscriptionPackages = useSelector(selectListSubscriptionPackage()),
        itemErrors = useSelector(selectErrors()),
        itemMasterData = useSelector(selectMasterData()),
        itemIsFetching = useSelector(selectFetching());

    useEffect(() => {
        if ((itemListSubscriptionPackages?.result || []).length < 1) {
            getListSubscriptionPackages();
        }
        getMasterData()
    }, []);

    useEffect(() => {
        setIsFetching(itemIsFetching)
    }, [itemIsFetching]);

    useEffect(() => {
        setResultList(itemListSubscriptionPackages?.result || [])
        setPagination({
            total: itemListSubscriptionPackages?.total || 0,
            totalPage: itemListSubscriptionPackages?.total_page || 0,
            defaultCurrent: itemListSubscriptionPackages?.page_index || 1,
            pageSize: itemListSubscriptionPackages?.page_size || 10
        })
    }, [itemListSubscriptionPackages]);

    const onTableChange = (pagination, filters, sorter) => {
        // let currentFilters = getCurrentFilters();
        filters = omit({...paramsFilters, ...filters}, ['page_index', 'page_size']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        setPramsFilters(newFilters)
        // setInitData({
        //     ...initData,
        //     filters: newFilters
        // });
        getListSubscriptionPackages(newFilters);
    };

    const onCreate = (e, data) => {
        if (e === TAG_DEFINE.ACTION_OPTIONS.UPDATE) {
            props.history.push((PERMISSION.PACKAGE.UPDATE.route).replace(":id", data.id))
        } else {
            // props.history.push(PERMISSION.PACKAGE.CREATE.route, {group: PERMISSION.PACKAGE.CREATE.group})
            // props.history.push(PERMISSION.PACKAGE.CREATE.route)
        }
    };

    const onSearch = (val) => {
        let getFilters = {...paramsFilters, ...val, page_index: 1};
        setPramsFilters(getFilters)
        getListSubscriptionPackages(removeObjectNullFull(getFilters));
    };

    return <>
        <HeaderAction title="Subscription Package List" disabledFormatUpperCaseTitle/>
        <div className="container-fluid px-4">
            <Form
                form={form}
                layout="vertical"
                onFinish={onSearch}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div className="row bg-white py-3 align-items-center">
                    <div className="col-2">
                        <Form.Item
                            label="Status"
                            name="status"
                        >
                            <Select
                                className="w-100"
                                allowClear
                            >
                                {
                                    (Object.keys(itemMasterData?.status || {})).length > 0 && (Object.keys(itemMasterData?.status || {})).map((i, k) => {
                                        return (
                                            <Select.Option value={itemMasterData?.status[i]}
                                                           key={k}>{i}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-2">
                        <Form.Item
                            label="Lead Type"
                            name="lead_type"
                        >
                            <Select
                                className="w-100"
                                allowClear
                            >
                                {
                                    (itemMasterData?.lead_type || []).length > 0 && itemMasterData?.lead_type.map((i, k) => {
                                        return (
                                            <Select.Option value={i}
                                                           key={k}>{i}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-2">
                        <Form.Item
                            label="State"
                            name="state"
                        >
                            <Select
                                className="w-100"
                                allowClear
                            >
                                {
                                    (itemMasterData?.state || []).length > 0 && itemMasterData?.state.map((i, k) => {
                                        return (
                                            <Select.Option value={i}
                                                           key={k}>{i}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-1">
                        <Form.Item className="text-end" label=" ">
                            <Button type="primary" htmlType="submit">
                                Search {isFetching && <Icon type="sync-outlined" spin/>}
                            </Button>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </div>
        <ListComponent
            scroll={{x: 1000}}
            classParent="m-0 p-0 col-md-12 mt-4"
            marginTop={'0'} marginBottom={'0'}
            loading={{spinning: isFetching, size: 'large'}}
            rowKey="id"
            dataSource={getDataSource(resultList || [], initData.modelItem)}
            columns={columnsTable({
                titleTable: initData.titleItemTable,
                component: componentTable,
                itemName: namePage
            })}
            pagination={{
                total: pagination.total,
                totalPage: pagination.totalPage,
                current: pagination.defaultCurrent,
                pageSize: pagination.pageSize
            }}
            onChange={onTableChange}
            componentTableList={{}}
        />
    </>
}

export default Index
